import React, { useState, useEffect } from 'react';
import { string, bool, node } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { EducationTooltip } from '@fiverr-private/orca';
import { localStorage } from '@fiverr-private/futile/lib/storage/localStorage';
import Tooltip from '@fiverr-private/fit/src/components/Tooltip';

const { POSITIONS } = Tooltip;

const ToggleTooltip = ({ showNotification, id, title, content, children, educationContent }) => {
    const key = `fiverr_education_tooltips.fiverr_education_tooltips.${id}_toggle_tooltip`;
    const [seenNotification, setSeenNotification] = useState();

    useEffect(() => {
        setSeenNotification(localStorage.get(key));
    }, [ seenNotification, key ]);

    if (showNotification && !seenNotification) {

        return (
            <EducationTooltip title={title}
                onClose={() => setSeenNotification(true)}
                badgeTitle={<I18n k="notifications.new"/>}
                body={educationContent}
                closeTitle={<I18n k="notifications.got_it"/>}
                tooltipStorageKey={key}
                position={POSITIONS.BOTTOM}>
                {children}
            </EducationTooltip>
        );
    }

    return (
        <Tooltip className="tooltip tooltip-toggler-wrapper"
            openClassName="tooltip-open"
            boxClassName="tooltip-box"
            boxContentClassName="tooltip-box-content"
            position={POSITIONS.BOTTOM} content={content}>
            {children}
        </Tooltip>
    );
};

ToggleTooltip.propTypes = {
    showNotification: bool,
    id: string,
    title: string,
    content: string,
    educationContent: string,
    children: node
};

export default ToggleTooltip;
